import { useState, useEffect, useMemo, useContext } from "react"
import axios from "axios"
import { TaxonomyPair } from "../components/KmControls"
import { Community } from "@models/user"
import { UserContext } from "src/providers/UserContext"
import { useLocalStorage } from "src/utils/useLocalStorage"

const exfluencyConfluence = "Exfluency Knowledge Base"
const generalKnowledge = "General Knowledge"

export const useTaxonomies = () => {
  const { userCommunities } = useContext(UserContext)
  const [hasDataSources, setHasDataSources] = useState<Record<string, boolean>>({})

  useEffect(() => {
    const checkDataSources = async () => {
      const dataSourceMap: Record<string, boolean> = {}

      // Check each community
      if (userCommunities) {
        for (const community of userCommunities) {
          try {
            const response = await axios.get(
              `/api/km/ingest/documents?communityId=${community.gatedCommunityId}&status=INGESTED&_limit=1`
            )
            dataSourceMap[community.gatedCommunityId] = parseInt(response.headers["x-total-count"] || "0") > 0
          } catch (e) {
            dataSourceMap[community.gatedCommunityId] = false
          }
        }
      }

      setHasDataSources(dataSourceMap)
    }

    checkDataSources()
  }, [userCommunities])

  const taxonomies = useMemo(() => {
    return [
      ...(userCommunities?.map((community) => ({
        name: community.gatedCommunityName,
        code: community.gatedCommunityId,
        group: "Community"
      })) || []),
      { name: exfluencyConfluence, code: "confluence", group: "Common" },
      { name: generalKnowledge, code: "general", group: "Common" }
    ].filter((taxonomy) => hasDataSources[taxonomy.code] !== false)
  }, [userCommunities, hasDataSources])

  const [selectedTaxonomy, setSelectedTaxonomy] = useLocalStorage<TaxonomyPair>(
    "taxonomy",
    taxonomies[0],
    (value: TaxonomyPair) => taxonomies.some((t) => t.code === value.code),
    [taxonomies]
  )

  return {
    hasDataSources,
    taxonomies,
    selectedTaxonomy,
    setSelectedTaxonomy
  }
}
